import type { FC } from 'react';
import './styles.scss';

type GoTopProps = {
  className?: string;
  onScrollUp?: () => void;
};

const scrollToTop = () => {
  window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
};

export const GoTop: FC<GoTopProps> = ({
  className = '',
  onScrollUp = scrollToTop,
}) => (
  <div
    className={`go-top ${className}`.trim()}
    onClick={onScrollUp}
    role="presentation"
  >
    <button
      type="button"
      className="icon icon__go-top"
      aria-label="Scroll to top"
    />
  </div>
);

export default GoTop;
